"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldFilters = void 0;
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var clsx_1 = __importDefault(require("clsx"));
var FIELDS = [
    {
        key: 'id',
        className: 'implioicons-hash',
    },
    {
        key: 'user',
        className: 'implioicons-user',
    },
    {
        key: 'ip',
        className: 'implioicons-ip',
    },
    {
        key: 'email',
        className: 'implioicons-mail',
    },
    {
        key: 'phone',
        className: 'implioicons-phone',
    },
];
function FieldFilter(props) {
    var _a;
    var field = props.field, note = props.note;
    var t = (0, react_i18next_1.useTranslation)().t;
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)((_a = {
                'moderation-note__fields__icon': true
            },
            _a[field.className] = true,
            _a['moderation-note__fields__icon--highlighted'] = note.matchingFields[field.key],
            _a)), title: note.matchingFields[field.key]
            ? t("ITEM.MODERATION_NOTES.ICON_TOOLTIP_REACT", { SCOPE: t("ITEM.MODERATION_NOTES.ICON_TOOLTIP_REACT_".concat(field.key)) })
            : '' }));
}
function FieldFilters(props) {
    var note = props.note;
    return (react_1.default.createElement("div", { className: "moderation-note__fields__icons" }, FIELDS.map(function (field) { return (react_1.default.createElement(FieldFilter, { key: field.key, field: field, note: note })); })));
}
exports.FieldFilters = FieldFilters;
